import { render, staticRenderFns } from "./HsabImportedClaimColumns.vue?vue&type=template&id=bc6f6356&scoped=true"
import script from "./HsabImportedClaimColumns.vue?vue&type=script&lang=ts"
export * from "./HsabImportedClaimColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6f6356",
  null
  
)

export default component.exports